// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"180":"2cca2479","386":"component---src-pages-index-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"180":"4651cb791f37b9427033","386":"e2e6b3c133806f222f8a","453":"92138820fcddc7dedcfb"}[chunkId] + ".js";
};